module.exports = __webpack_public_path__ + "static/media/Microsoft Surface Book.9b0f1654.png";